<div class="dialog-header">
  <h2 mat-dialog-title class="dialog-title">Change role — {{ data.userEmail }}</h2>
  <p class="dialog-subtitle">Move this user to another role within the same family.</p>
</div>

<mat-dialog-content class="dialog-content">
  <app-error-banner [message]="errorMessage()" />

  <p class="hint">Current role: <strong>{{ data.currentRole }}</strong></p>

  <mat-form-field appearance="outline">
    <mat-label>New role</mat-label>
    <mat-select [(ngModel)]="selectedRole" name="role">
      @for (role of availableRoles; track role) {
        <mat-option [value]="role">{{ role }}</mat-option>
      }
    </mat-select>
    <mat-hint>Can only move within the same role family, never between company and platform staff.</mat-hint>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions" align="end">
  <button mat-stroked-button class="btn-cancel" (click)="cancel()" [disabled]="isSubmitting()">Cancel</button>
  <button mat-flat-button class="btn-submit" (click)="submit()" [disabled]="isSubmitting() || !canSubmit">
    @if (isSubmitting()) {
      <mat-icon class="spinner">progress_activity</mat-icon>
    }
    {{ isSubmitting() ? 'Saving…' : 'Change role' }}
  </button>
</mat-dialog-actions>
